var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"placeholder":"Input column name","state":_vm.state},on:{"input":_vm.onInputColumnName},model:{value:(_vm.columnName),callback:function ($$v) {_vm.columnName=$$v},expression:"columnName"}})}
var staticRenderFns = []

export { render, staticRenderFns }